define('rebrush/components/product/view/wheretobuy',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'cartware/components/Registry',
	'cartware/components/Config',
	'modernizr',
	'elevatezoom',
	'cartware-slider',
	'magnific-popup'
], function(
	$,
	_,
	Component,
	BEM,
	Registry,
	Config
) {
	return Component.create({
		slotBlock:				null,
		currentBlock:			null,
		spConfig:				null,
		cachedBlocks:			null,
		stockNotificationBlock: null,
		onDestroyCallbacks: 	null,
		dividerHtml: 			null,

		constructor: function() {
			this.cachedBlocks = {};
			this.onDestroyCallbacks = [_.bind(function() {
				this.spConfig = null;
				this.cachedBlocks = null;
			}, this)];
		},

		$init: function() {
			this.dividerHtml = '<div class="' + BEM.buildElementClassname('gigaset-wheretobuy-addto', 'divider') + '">' +
				'<span class="' + BEM.buildElementClassname('gigaset-wheretobuy-addto', 'divider-label') + '">' + Translator.translate('or') + '</span></div>';
			this.initializeConfigurable();
			this.initializeSimple();
		},

		initializeConfigurable: function() {
			this.slotBlock = BEM.block('gigaset-wheretobuy-configurable-slot');

			Registry().retrieve('product.view.configurable.spConfig', _.bind(function(spConfig) {
				this.spConfig = spConfig;
				this.initializeSimpleObservation();
			}, this));
		},

		initializeSimple: function() {
			this.currentBlock = BEM.block('gigaset-wheretobuy-addto');
			var button = this.currentBlock.getElements('button');

			// this.rearrangeBlocks();

			// var onClick = _.bind(function(e) {
			// 	e.preventDefault();
			//
			// 	$.magnificPopup.open({
			// 		mainClass: 'mfp--where-to-buy test',
			// 		fixedContentPos: true,
			// 		items: {
			// 			src: button.attr('href'),
			// 			type: 'iframe',
			// 			mainClass: 'mfp--where-to-buy test',
			// 		},
			// 		callbacks: {
			// 			open: function () {
			// 				if ($.magnificPopup.instance.isOpen) {
			// 					console.log('into2');
			// 				}
			// 				var popup = $('.popup-body');
			// 				console.log(popup);
			// 			}
			// 		}
			// 	});
			// }, this);
			//
			// if ($.magnificPopup.instance.isOpen) {
			// 	console.log('into');
			// }

			var openPopup = _.bind(function(e) {
				this.openPopup(e, button);
			}, this);

			button.on('click', openPopup);

			// button.on('click', this.test());
			this.onDestroyCallbacks.push(_.bind(function() {
				button.off('click', openPopup);
			}, this));
		},

		openPopup: function(e, button) {
			e.preventDefault();

			$.magnificPopup.open({
				mainClass: 'mfp--where-to-buy',
				fixedContentPos: true,
				items: {
					src: button.attr('href'),
					type: 'iframe',
				}
			});

			if ($.magnificPopup.instance.isOpen) {
				var mfpContainer = $('.mfp-wrap');
				if (mfpContainer.length) {
					var classList = mfpContainer.get(0).classList;
					if (!classList.contains('mfp--where-to-buy')) {
						mfpContainer.addClass('mfp--where-to-buy');
					}
					if (classList.contains('container-size')) {
						mfpContainer.removeClass('container-size');
					}
				}
			}
		},

		rearrangeBlocks: function() {
			this.stockNotificationBlock = BEM.block('product-stocknotification');

			if (this.stockNotificationBlock.length && this.currentBlock.length) {
				var visibility = this.stockNotificationBlock.css('display');
				if (visibility !== 'none' && visibility !== 'hidden') {
					// this.currentBlock.append(this.dividerHtml);
					this.currentBlock.after(this.stockNotificationBlock);
				}
			}
		},

		initializeSimpleObservation: function() {
			var currentSimple = _.get(this.spConfig, '__currentGallerySimple');
			var _onChangeSimple = _.bind(function(e, simple) {
				this.changeSimple(simple);
			}, this);

			$(document).on('product/changeSimple', _onChangeSimple);

			this.onDestroyCallbacks.push(_.bind(function() {
				$(document).off('product/changeSimple', _onChangeSimple);
			}, this));

			if (currentSimple) {
				_onChangeSimple(null, currentSimple);
			}
		},

		changeSimple: function(simple) {
			var html = _.get(simple, 'gigaset_wheretobuy.addto', null),
				id = _.get(simple, 'id', 'undefined', null),
				block = _.get(this.cachedBlocks, id, null);

			this.slotBlock.empty();

			if (null !== html) {
				if (null === block) {
					block = $('<div />').html(html);
					_.set(this.cachedBlocks, id, block);
					this.slotBlock.append(block);
					this.initializeSimple();
				} else {
					this.slotBlock.append(block);
				}
			}
		},

		destructor: function() {
			this.spConfig = null;
		}
	});
});
